import * as React from 'react'
import CloudinaryImage from 'web-makeup/dist/CloudinaryImage'
import { Margin } from 'web-makeup/dist/design-system/styles/spacings'
import { Text } from 'web-makeup/dist/design-system/styles/typography'

import { Wrapper, OrdersButton, InnerWrapper } from './NoOrders.style'

export interface NoOrdersProps {
  icon?: string
  title?: string
  content?: string
  buttonText?: string
  buttonOnClick?: () => void
}

const NoOrders: React.FC<NoOrdersProps> = ({ icon, title, content, buttonText, buttonOnClick }) => {
  return (
    <Wrapper>
      <InnerWrapper>
        <CloudinaryImage
          useSourceFormat
          source={{
            id: icon || '',
            type: 'upload',
          }}
        />
        <div>
          <Text as="h3" fontSize="h0" color="black1" fontWeight="black">
            {title}
          </Text>
          <Margin bottom size="xxSmall" />
          <Text as="p" fontSize="h3" color="black1">
            {content}
          </Text>
          <OrdersButton onClick={buttonOnClick}>{buttonText}</OrdersButton>
        </div>
      </InnerWrapper>
    </Wrapper>
  )
}

export default NoOrders



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/NoOrders/NoOrders.tsx